import { Box, styled } from "@mui/material";
import { useHistory } from "react-router-dom";

import SB from "@/Components/Icons/SB";
import { ButtonBasic } from "@/Components/v2/atoms/Button/ButtonBasic";

import { StatusAlert } from "./StatusAlert";

const StyledCreateScenarioButton = styled(ButtonBasic)(({ theme }) => ({
  borderRadius: "100px",
  padding: theme.spacing(1.5, 2.5),
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
}));

const DISCLAIMER = `All future estimations are based on existing data and should be treated as projections. For
        detailed forecasts or predictions, please use Scenario Builder.`;
export const ScenarioBuilderDisclaimer = () => {
  const history = useHistory();

  const handleCreateNewScenario = () => {
    history.push("/scenarios-v3/all", {
      background: true,
    });
  };

  return (
    <Box mb={3}>
      <StatusAlert title="Important" sx={{ mb: 1.5 }} severity="info">
        {DISCLAIMER}
      </StatusAlert>
      <StyledCreateScenarioButton
        variant="contained"
        color="primary"
        onClick={handleCreateNewScenario}
      >
        <SB
          fontSize="small"
          sx={{
            mr: 1,
          }}
        />
        Create New Scenario
      </StyledCreateScenarioButton>
    </Box>
  );
};
